import { DASH_META_ROOT, getAuthDashMetaCsrfToken } from '@revelio/auth';
import type { UploadFileResult } from '@revelio/data-access';

export const uploadFileToStorage = async ({
  blob,
  fileName,
}: {
  blob: Blob;
  fileName: string;
}): Promise<UploadFileResult> => {
  const formData = new FormData();
  formData.append('file', blob, fileName);
  formData.append('fileName', fileName);

  const csrfToken = getAuthDashMetaCsrfToken();
  const resp = await fetch(
    `${DASH_META_ROOT}/api/storage/upload?provider=onlyoffice`,
    {
      method: 'POST',
      body: formData,
      credentials: 'include',
      headers: {
        'x-surf-token-dash-meta': csrfToken || '',
      },
    }
  );
  if (!resp.ok) {
    throw new Error('Failed to upload file to storage');
  }
  const data = (await resp.json()) as UploadFileResult;
  return data;
};
